import {
  BikesType,
  BikesTypeLabel,
} from '@bikes/store/storeSlices/bikesDetails';
import { Link } from '@atoms/Link';

interface UploadPhotoTextContentProps {
  bikesType: BikesType | null;
  bikesTypeLabel: BikesTypeLabel | null;
}

export const UploadPhotoTextContent = ({
  bikesType,
  bikesTypeLabel,
}: UploadPhotoTextContentProps) => {
  const imageDisclaimerLink = {
    href: 'https://www.westminster.gov.uk/data-protection/report-it-image-disclaimer',
    text: 'Find out how we will be using your image.',
  };

  const context = bikesType === BikesType.HireScooters ? 'scooters' : 'bikes';

  return (
    <div className="text-bodyLg my-4 flex flex-col gap-4">
      <p>Photos help us locate and assess the issue.</p>
      <p>
        <Link
          href={imageDisclaimerLink.href}
          className="inline font-normal"
          linkType="inline"
          title="Opens in a new tab"
          external={true}
        >
          {imageDisclaimerLink.text}
        </Link>
      </p>
      <p className="font-semibold">
        Only if it is safe to do so, please take a photo of the
        {' ' + bikesTypeLabel} and the surroundings.
      </p>
      {bikesType === BikesType.Bikes ? null : (
        <>
          <p>You can upload a photo of the QR code if you have it.</p>
          <p>
            {`If the ${context} are from different providers, you can upload the details, 
              but you will need to make a separate report for each provider. We can only accept one provider at a time.`}
          </p>
        </>
      )}
      <p>You can upload up to five images.</p>
      <p>You can upload JPEG, PNG, GIF or WebP files.</p>
    </div>
  );
};
